<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="-mt-1">
          <button *ngIf="validaButtonRedireciona" class="btn btn-info btn-sm" (click)="voltar()">
            <em class="fa fa-arrow-left"></em>
          </button>
        </div>
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.veiculoVendido.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoVendido.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'relatorioVeiculos.veiculoVendido.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoVendido.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'relatorioVeiculos.veiculoVendido.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'relatorioVeiculos.veiculoVendido.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'relatorioVeiculos.veiculoVendido.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loading" class="text-center mt-4 mb-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem; color: #007bff;"></i>
    </div>
    <div translate *ngIf="!loading && dealersDados?.length <= 0" class="sem-registros text-muted mt-2">
      {{'rmpv.detalhado.nenhumRegistroExibir'}}
    </div>
    <p-table #dt *ngIf="!loading && dealersDados?.length > 0" [value]="dealersDados" dataKey="id" selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
      [paginator]="dealersDados?.length > 10" [rows]="10" [loading]="loading" [columns]="cols" [value]="rows"
      [autoLayout]="false" [scrollable]="true" scrollDirection="horizontal" [style]="{ 'width': '100%' }"
      currentPageReportTemplate="{{'relatorioVeiculos.veiculoVendido.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
      [globalFilterFields]="['dealer','chassi','marca',
        'modelo','valorVenda','corExterna','anoModelo','situacao','status','proposta','data', 'dataVenda','dataEntrega', 'nomeCliente', 'email']" id="excel-table">
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'relatorioVeiculos.veiculoVendido.filtroGeral' | translate}}" />
          </span>

          <p-multiSelect *ngIf="this.translate.currentLang == 'br'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{'relatorioVeiculos.veiculoVendido.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'relatorioVeiculos.veiculoVendido.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
          <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{'relatorioVeiculos.veiculoVendido.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'relatorioVeiculos.veiculoVendido.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th class="text-center" [translate]="getTranslate(col.header)" [pSortableColumn]="col.field"
              [style.width]="col.width"
              style="background-color:black;color:white;">
              {{ col.header }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-dealer let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td class="text-center" [style.width]="col.width"
              [title]="(col.field === 'data' || col.field === 'dtEntrega') ? (dealer[col.field] | date: 'dd/MM/yyyy HH:mm:ss') : (col.type ? col.type.transform(dealer[col.field], col.arg1) : dealer[col.field])">
              <div [ngClass]="{'dealer': col.field === 'nome'}">
                <ng-container *ngIf="col.field === 'data' || col.field === 'dtEntrega'; else defaultDisplay">
                  {{ dealer[col.field] | date: 'dd/MM/yyyy HH:mm:ss' }}
                </ng-container>
                <ng-template #defaultDisplay>
                  {{ col.type ? col.type.transform(dealer[col.field], col.arg1) : dealer[col.field] }}
                </ng-template>
                <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dealer)"></ng-container>
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.grupoEconomicoPlaceHolder' | translate }}"
            [options]="gruposEconomicos" optionLabel="descricao" optionValue="id" formControlName="grupo_economico"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.chassi'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.chassiPlaceHolder' | translate}}"
            formControlName="chassi">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'Status Veículo'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.tipoPlaceHolder' | translate }}" [options]="tipo"
            optionLabel="nome" optionValue="valor" formControlName="situacao" [autoDisplayFirst]="false"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.statusNota'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.tipoPlaceHolder' | translate }}" 
            optionLabel="nome" optionValue="valor" formControlName="status" [autoDisplayFirst]="false"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm" [options]="statusNota">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.vendaDireta'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.vendaPlaceHolder' | translate }}"
            [options]="vendaDireta" optionLabel="nome" optionValue="valor" formControlName="vendaDireta"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'relatorioVeiculos.veiculoVendido.filtrar'}}</button>
  </ng-template>
</p-dialog>
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>
